<template>
  <TableRegular
    :loading="loading"
    :rows="rows"
    :columns="columns"
    :sort="sort"
    :page="page"
    :per-page="perPage"
    :page-size="pageSize"
    :total-page="totalPage"
    :total-records="totalRecords"
    :footer-amount="footerAmount"
    :line-numbers="lineNumbers"
    :custom-filters="customFilters"
    @onFilter="$emit('onFilter', $event)"
    @onPageChange="$emit('onPageChange', $event)"
    @onPerPageChange="$emit('onPerPageChange', $event)"
    @onSortChange="$emit('onSortChange', $event)"
    @onChangeCustomFilter="$emit('onChangeCustomFilter', $event)"
  >
    <template slot="table-row" slot-scope="props">
      <template v-if="props.column.field === 'user'">
        <CustomerDetailsPopover :user="props.row.user" :another-key="props.row.id" />
      </template>
      <template v-else-if="props.column.field === 'phone'">
        {{ props.row.user ? props.row.user.phone : '' }}
      </template>
      <template v-else-if="props.column.field === 'registrationNumber'">
        {{ props.row.user ? props.row.user.registrationNumber : '' }}
      </template>
      <template v-else-if="props.column.field === 'firstOfficer'">
        {{ props.row.firstOfficer ? props.row.firstOfficer.firstName : '' }}
      </template>
      <template v-else-if="props.column.field === 'officer'">
        {{ props.row.officer ? props.row.officer.firstName : '' }}
      </template>
      <template v-else-if="props.column.field === 'amount'">
        <LoanDetailsPopover :loan="props.row" :another-key="props.row.user.id" />
      </template>
      <div v-else-if="props.column.field === 'status'" class="whitespace-nowrap">
        <div :class="['status', `is-${getStatus(props.row.status)}`]">
          {{ $t(`status.${getStatus(props.row.status)}`) }}
        </div>
      </div>
      <p v-else-if="props.column.field === 'endDate'" class="whitespace-nowrap">
        {{ props.row.endDate }}
      </p>
      <p v-else-if="props.column.field === 'action'" class="flex justify-end items-center">
        <router-link
          v-if="$route.name !== 'LoansPending'"
          :to="{ name: 'LoanDetails', params: { loanId: props.row.id } }"
          class="flex items-center mr-3"
        >
          <EyeIcon class="w-4 h-4" />
        </router-link>
        <button
          v-if="$route.name === 'LoansPending'"
          @click="$emit('lending', props.row.id)"
          type="submit"
          class="flex items-center mr-3"
          :disabled="lendingStatus === 'loading' && lendingId === props.row.id"
        >
          <ArrowDownCircleIcon class="w-4 h-4" />
        </button>
        <button
          v-if="$route.name === 'LoansPending'"
          @click="$emit('delete', props.row.id)"
          type="button"
          class="flex items-center text-theme-6"
        >
          <xIcon class="w-4 h-4" />
        </button>
      </p>
    </template>
  </TableRegular>
</template>

<script>
import TableRegular from '@/components/ui/table/TableRegular';
import tableMixin from '@/mixins/tableMixin';
import CustomerDetailsPopover from '@/components/customer/CustomerDetailsPopover';
import LoanDetailsPopover from '@/components/loan/LoanDetailsPopover';
import humps from 'humps';

export default {
  mixins: [tableMixin],

  props: {
    lendingStatus: Boolean,
    lendingId: {
      type: Number,
      default: null,
    },
  },

  components: {
    TableRegular,
    CustomerDetailsPopover,
    LoanDetailsPopover,
  },

  methods: {
    getStatus(status) {
      return status ? humps.camelize(status).toLowerCase() : '';
    },
  },
};
</script>
